import {
  useLazyChildComment,
  useSwitchGetChildCommentScope,
} from "@/hooks/useComment";
import { CommentScope } from "@/interfaces/comment.interface";
import { List } from "antd";
import MyChildComment from "./MyChildComment";

interface IProps {
  parentId: string;
  scope: CommentScope;
}

const MyChildCommentList: React.FC<IProps> = ({ parentId, scope }) => {
  const { page, size, setPageSize, loading } = useLazyChildComment(
    parentId,
    scope
  );
  const comments = useSwitchGetChildCommentScope(scope, parentId);

  return (
    <List
      dataSource={comments?.results ?? []}
      itemLayout="horizontal"
      loading={loading}
      renderItem={(props) => (
        <MyChildComment comment={props} parentId={parentId} scope={scope} />
      )}
      pagination={{
        total: comments?.count || 0,
        pageSize: size,
        current: page,
        onChange: (page, size) => setPageSize({ page, size }),
        showSizeChanger: true,
        hideOnSinglePage: true,
        pageSizeOptions: ["3", "10", "20"],
      }}
      split
    />
  );
};

export default MyChildCommentList;
